import { forwardRef } from 'react';
import styled from 'styled-components'
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import Text from '../atoms/Text';

const Container = styled.div`
  width: auto;
  min-width: 80px;
  height: auto;
  position: fixed;
  top: 66px;
  right: 16px;
  @media (min-width: 600px) {
    right: calc((100vw - 600px) / 2 + 16px);
  }
  border: 1px solid ${(props) =>  props.theme.colors.neutral[400]};
  border-radius: 10px;
  background-color: ${(props) =>  props.theme.colors.neutral[100]};
  box-shadow: 0px 0px 8px rgba(0,0,0,0.1);
  hr {
    border: 1px solid ${(props) =>  props.theme.colors.neutral[300]};
  }
  z-index: 100;
  overflow: hidden;
`
const MenuButton = styled.button`
  width: 100%;
  background-color: ${(props) =>  props.theme.colors.neutral[100]};
  padding: 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 4px;
  border: none;
`
const EditIcon = styled(EditOutlinedIcon)`
  color: ${(props) =>  props.theme.colors.primary};
` 
const DeleteIcon = styled(DeleteOutlineIcon)`
  color: ${(props) =>  props.theme.colors.status.error};
`

const ConversationDetailDropdown = forwardRef(({ onEdit, onDelete }, ref) => {
  return (
    <Container ref={ref}>
      <MenuButton onClick={onEdit}>
        <Text>제목 수정</Text>
        <EditIcon/>
      </MenuButton>
      <hr/>
      <MenuButton onClick={onDelete}>
        <Text color="error">대화 삭제</Text>
        <DeleteIcon/>
      </MenuButton>
    </Container>
  )
});

export default ConversationDetailDropdown
